import styled from 'styled-components';
import Link from '@splunk/react-ui/Link';
import { mixins, variables } from '@splunk/themes';

export const StyledSkipLink = styled(Link)`
    ${mixins.skipLink()};
    &:not([disabled], [aria-disabled='true']) {
        background-color: ${variables.backgroundColorSection};
    }
    &&& {
        text-decoration: none;
    }
    &:focus {
        z-index: ${variables.zindexLayer};
    }
`;
